import React, { useContext } from 'react';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import { PriceSimulatorSteps } from 'utils/Enums';

type props = {
    currentStep: number;
    onNavigationClickHandler: (val: number) => void;
    isLastStepDisabled?: boolean;
    viewMode?: boolean;
    scenarioId: number;
};

const FooterStep = (props: props) => {
    const { onNavigationClickHandler, isLastStepDisabled } = props;

    const {
        currentStep,
        viewMode,
        simulationInputLoading,
        changedPortfolioUpdateKpisLoading,
        scenarioId,
        portfolioUpdateKpisLoading,
        kpiMetricsLoading,
    } = useContext(priceSimulatorDataContext);

    const isNextButtonDisabled =
        isLastStepDisabled ||
        (currentStep === PriceSimulatorSteps.GOAL_STEP && kpiMetricsLoading) ||
        (currentStep === PriceSimulatorSteps.PORTFOLIO_UPDATE_STEP && portfolioUpdateKpisLoading) ||
        (currentStep === PriceSimulatorSteps.IDENTIFY_OPPORTUNITY_STEP && (viewMode || simulationInputLoading)) ||
        changedPortfolioUpdateKpisLoading;

    const hasSimulationBeenTriggered = scenarioId !== 0;

    const notes =
        currentStep === 2
            ? 'Values present in the table are Retail Sales Value'
            : currentStep === 3
            ? 'If you do not enter any value, the recommended value will be considered for simulation.'
            : '';

    return (
        <>
            <div
                className={`h-20  z-50 absolute w-full ${
                    notes ? 'bottom-6' : 'bottom-6'
                } left-0 rounded-b bg-bgBackground `}
            >
                <div className="flex h-20 w-full items-center bg-blue-100 px-16">
                    <div onClick={() => onNavigationClickHandler(currentStep - 1)}>
                        <span
                            className={`rounded bg-white px-8 py-2 border font-semibold cursor-pointer border-purpleFont text-purpleFont   `}
                        >
                            Back
                        </span>
                    </div>
                    <div className="mx-32 flex grow items-center justify-between">
                        {/* step 1 */}
                        <div className="relative">
                            <div
                                className={`flex h-8 w-8 border items-center justify-center rounded-full p-2  ${
                                    currentStep === 1 ? 'border-purpleFont  bg-white' : ''
                                }
                            ${currentStep > 1 ? 'border-purpleFont  bg-purpleFont text-white' : ''}
                            `}
                            >
                                <span>1</span>
                            </div>
                            <div
                                className={`absolute inset-x-1/2 -bottom-full w-64 -translate-x-2/4 -translate-y-2/4 text-center text-sm ${
                                    currentStep === 1 ? 'font-semibold' : ''
                                }`}
                            >
                                Goals
                            </div>
                        </div>

                        <span
                            className={`mx-4 h-1 grow rounded   ${
                                currentStep >= 2 ? 'bg-purpleFont' : 'bg-borderGrey'
                            }`}
                        />
                        {/* step 2 */}
                        <div className="relative">
                            <div
                                className={`flex h-8 w-8 border items-center justify-center rounded-full p-2  ${
                                    currentStep === 2 ? 'border-purpleFont  bg-white' : ''
                                }
                            ${currentStep > 2 ? 'border-purpleFont  bg-purpleFont text-white' : ''}
                            ${currentStep < 2 ? 'border-borderGrey  bg-white text-borderGrey' : ''}`}
                            >
                                <span>2</span>
                            </div>
                            <div
                                className={`absolute inset-x-1/2 -bottom-full w-64 -translate-x-2/4 -translate-y-2/4 text-center text-sm ${
                                    currentStep === 2 ? 'font-semibold' : ''
                                }`}
                            >
                                Portfolio update
                            </div>
                        </div>

                        <span
                            className={`mx-4 h-1 grow rounded   ${
                                currentStep === 3 ? 'bg-purpleFont' : 'bg-borderGrey'
                            }`}
                        />

                        {/* step 3 */}
                        <div className="relative">
                            <div
                                className={`flex h-8 w-8 border items-center justify-center rounded-full p-2  ${
                                    currentStep === 3 && !hasSimulationBeenTriggered
                                        ? 'border-purpleFont  bg-white'
                                        : ''
                                }
                            ${
                                currentStep > 3 || hasSimulationBeenTriggered
                                    ? 'border-purpleFont  bg-purpleFont text-white'
                                    : ''
                            }
                            ${currentStep < 3 ? 'border-borderGrey  bg-white text-borderGrey' : ''}`}
                            >
                                <span>3</span>
                            </div>
                            <div
                                className={`absolute inset-x-1/2 -bottom-full w-64 -translate-x-2/4 -translate-y-2/4 text-center text-sm ${
                                    currentStep === 3 ? 'font-semibold' : ''
                                }`}
                            >
                                Identify Opportunities
                            </div>
                        </div>
                    </div>

                    <div
                        onClick={() => !isNextButtonDisabled && onNavigationClickHandler(currentStep + 1)}
                        style={{ minWidth: '90px' }}
                        className={`rounded  py-2 border font-semibold  text-center  ${
                            isNextButtonDisabled
                                ? 'cursor-not-allowed border-borderGrey bg-borderGrey text-promoColour'
                                : 'cursor-pointer border-purpleFont  bg-purpleFont text-white'
                        }`}
                    >
                        {currentStep === 3 ? 'Simulate' : 'Next'}
                    </div>
                </div>
            </div>
            <div
                className={`h-6 pl-6 w-full absolute text-fontGray font-xxs font-normal bottom-0 left-0 rounded-b bg-greyBackgroundAlt border-t border-borderLinePurpuleAlt flex items-center`}
            >
                <span>{notes}</span>
            </div>
        </>
    );
};

export default FooterStep;
